/*
 * @Author: Src
 * @Date: 2025-03-25 10:12:29
 * @LastEditTime: 2025-07-10 16:46:49
 * @LastEditors: Src
 * @FilePath: /work-station/src/models/wark.ts
 * @Description: 运营工作台表头
 */

import _ from 'lodash';

export class warkLabel {
  static init(type: any) {
    let data: any = [];
    const obj: any = {
      OperationalLabel,
      OperationalLabelKa,
      MinisterialLabel,
      MinisterialLabelKa,
      PerformanceLeader,
      PerformanceLeaderKa,
      PromotionColumns,
      PromotionCompletion,
      PromotionCompletionRate: promotionCompletionRate,
      PromoteDailyData,
      AdvertiserFollowUp,
      PerformanceTargetConfiguration,
      CPSInvestmentPromotion,
      WriteGMVAmount,
      ListRechargeStores,
    };
    if (obj[type]) {
      data = _.cloneDeep(obj[type]);
    }

    return data;
  }
}
// 运营绩效标签数据模型
const OperationalLabel: any[] = [
  {
    title: '部长',
    dataIndex: 't_leader',
    align: 'center',
    width: 100,
  },
  {
    title: '组长',
    dataIndex: 'leader',
    align: 'center',
    width: 100,
  },
  {
    title: '档位级别',
    dataIndex: 'agent_level',
    align: 'center',
    width: 100,
  },
  {
    title: '组员',
    dataIndex: 'username',
    align: 'center',
    width: 160,
  },
  {
    title: '总分',
    dataIndex: 'total_score',
    align: 'center',
    width: 100,
  },
  {
    title: '客观得分',
    dataIndex: 'one',
    align: 'center',
    children: [
      {
        title: 'SKU要求',
        dataIndex: 'sku_score',
        align: 'center',
        width: 100,
      },
      {
        title: '门店巡查',
        dataIndex: 'inspection_and_exp',
        align: 'center',
        width: 100,
      },
      {
        title: '参加活动',
        dataIndex: 'activity_investment',
        align: 'center',
        width: 100,
      },
      {
        title: '应充实充量增长',
        dataIndex: 'recharge_rate',
        align: 'center',
        width: 160,
      },
      {
        title: '撞线完成率',
        dataIndex: 'complete_overflow',
        align: 'center',
        width: 120,
      },
      {
        title: '在投门店数量增长',
        dataIndex: 'investing_rate',
        align: 'center',
        width: 150,
      },
      {
        title: '合并支付完成投放',
        dataIndex: 'deployed_qualified',
        align: 'center',
        width: 160,
      },
      {
        title: '响应时长',
        dataIndex: 'response_time',
        align: 'center',
        width: 100,
      },
      {
        title: '门店客诉',
        dataIndex: 'customer_complaint',
        align: 'center',
        width: 100,
      },
      {
        title: '运营月考',
        dataIndex: 'monthly_test',
        align: 'center',
        width: 100,
      },
    ],
  },
  {
    title: '个人贡献加分',
    dataIndex: 'department',
    align: 'center',
    children: [
      {
        title: '商户质量抵扣分',
        dataIndex: 'deduct_points',
        align: 'center',
        width: 140,
      },
      {
        title: '加分',
        dataIndex: 'bonus_points',
        align: 'center',
        width: 100,
      },
      {
        title: '备注',
        dataIndex: 'department',
        align: 'center',
        width: 100,
      },
    ],
  },
];
// 运营绩效Ka标签数据模型
const OperationalLabelKa: any[] = [
  {
    title: '部长',
    dataIndex: 't_leader',
    align: 'center',
    width: 100,
  },
  {
    title: '组长',
    dataIndex: 'leader',
    align: 'center',
    width: 100,
  },
  {
    title: '档位级别',
    dataIndex: 'agent_level',
    align: 'center',
    width: 100,
  },
  {
    title: '组员',
    dataIndex: 'username',
    align: 'center',
    width: 100,
  },
  {
    title: '总分',
    dataIndex: 'total_score',
    align: 'center',
    width: 100,
  },
  {
    title: '客观得分',
    dataIndex: 'one',
    align: 'center',
    children: [
      {
        title: 'SKU上品(5分)',
        dataIndex: 'sku_score',
        align: 'center',
        width: 140,
      },
      {
        title: '品牌权益配置(5分)',
        dataIndex: 'brand_equity',
        align: 'center',
        width: 160,
      },
      {
        title: '门店巡店/异常处理(5分)',
        dataIndex: 'inspection_and_exp',
        align: 'center',
        width: 200,
      },
      {
        title: '活动招商(5分)',
        dataIndex: 'activity_investment',
        align: 'center',
        width: 140,
      },
      {
        title: '门店客诉(10分)',
        dataIndex: 'customer_complaint',
        align: 'center',
        width: 140,
      },
      {
        title: '响应时长(10分)',
        dataIndex: 'response_time',
        align: 'center',
        width: 140,
      },
      {
        title: '应充实充率增长(10分)',
        dataIndex: 'recharge_rate',
        align: 'center',
        width: 180,
      },
      {
        title: '品牌续费率(50分)',
        dataIndex: 'brand_renew_rate',
        align: 'center',
        width: 160,
      },
    ],
  },
  {
    title: '个人贡献加分',
    dataIndex: 'department',
    align: 'center',
    children: [
      {
        title: '商户质量抵扣分',
        dataIndex: 'deduct_points',
        align: 'center',
        width: 140,
      },
      {
        title: '加分',
        dataIndex: 'bonus_points',
        align: 'center',
        width: 100,
      },
      {
        title: '备注',
        dataIndex: 'department3',
        align: 'center',
        width: 100,
      },
    ],
  },
];
// 运营绩效部长标签数据模型
const MinisterialLabel: any[] = [
  {
    title: '部长',
    dataIndex: 't_leader',
    align: 'center',
    width: 120,
  },
  {
    title: '总分',
    dataIndex: 'total_score',
    align: 'center',
    width: 120,
  },
  {
    title: '商户运营',
    dataIndex: 'one',
    align: 'center',
    width: 120,
    children: [
      {
        title: 'SKU要求',
        dataIndex: 'sku_score',
        align: 'center',
        width: 120,
      },
      {
        title: '门店巡查',
        dataIndex: 'inspection_and_exp',
        align: 'center',
        width: 120,
      },
      {
        title: '参加活动',
        dataIndex: 'activity_investment',
        align: 'center',
        width: 120,
      },
    ],
  },
  {
    title: '目标管理',
    dataIndex: 'two',
    align: 'center',
    children: [
      {
        title: '应充实充率增长',
        dataIndex: 'recharge_rate',
        align: 'center',
        width: 140,
      },
      {
        title: '撞线完成率',
        dataIndex: 'complete_overflow',
        align: 'center',
        width: 120,
      },
      {
        title: '在投门店数量增长',
        dataIndex: 'investing_rate',
        align: 'center',
        width: 160,
      },
      {
        title: '合并支付完成投放',
        dataIndex: 'deployed_qualified',
        align: 'center',
        width: 160,
      },
      {
        title: '响应时长',
        dataIndex: 'response_time',
        align: 'center',
        width: 120,
      },
      {
        title: '门店客诉',
        dataIndex: 'customer_complaint',
        align: 'center',
        width: 120,
      },
      {
        title: '运营月考',
        dataIndex: 'monthly_test',
        align: 'center',
        width: 120,
      },
    ],
  },
];
// 运营绩效KA部长标签数据模型
const MinisterialLabelKa: any[] = [
  {
    title: '部长',
    dataIndex: 't_leader',
    align: 'center',
    width: 120,
  },
  {
    title: '总分',
    dataIndex: 'total_score',
    align: 'center',
    width: 120,
  },
  {
    title: '客观得分',
    dataIndex: 'one',
    align: 'center',
    children: [
      {
        title: 'SKU上品(5分)',
        dataIndex: 'sku_score',
        align: 'center',
        width: 140,
      },
      {
        title: '品牌权益配置(5分)',
        dataIndex: 'brand_equity',
        align: 'center',
        width: 160,
      },
      {
        title: '门店巡店/异常处理(5分)',
        dataIndex: 'inspection_and_exp',
        align: 'center',
        width: 200,
      },
      {
        title: '活动招商(5分)',
        dataIndex: 'activity_investment',
        align: 'center',
        width: 140,
      },
      {
        title: '门店客诉(10分)',
        dataIndex: 'customer_complaint',
        align: 'center',
        width: 140,
      },
      {
        title: '响应时长(10分)',
        dataIndex: 'response_time',
        align: 'center',
        width: 140,
      },
      {
        title: '应充实充率增长(10分)',
        dataIndex: 'recharge_rate',
        align: 'center',
        width: 180,
      },
      {
        title: '品牌续费率(50分)',
        dataIndex: 'brand_renew_rate',
        align: 'center',
        width: 160,
      },
    ],
  },
];
// 运营绩效组长标签数据模型
const PerformanceLeader: any[] = [
  {
    title: '部长',
    dataIndex: 't_leader',
    align: 'center',
    width: 120,
  },
  {
    title: '组长',
    dataIndex: 'leader',
    align: 'center',
    width: 120,
  },
  {
    title: '总分',
    dataIndex: 'total_score',
    align: 'center',
    width: 120,
  },
  {
    title: '小组推广通金额',
    dataIndex: 'real_price_all',
    align: 'center',
    width: 140,
  },
  {
    title: '商户运营',
    align: 'center',
    width: 120,
    children: [
      {
        title: 'SKU要求',
        dataIndex: 'sku_score',
        align: 'center',
        width: 120,
      },
      {
        title: '门店巡查',
        dataIndex: 'inspection_and_exp',
        align: 'center',
        width: 120,
      },
      {
        title: '参加活动',
        dataIndex: 'activity_investment',
        align: 'center',
        width: 120,
      },
    ],
  },
  {
    title: '目标管理',
    align: 'center',
    width: 120,
    children: [
      {
        title: '应充实充率增长',
        dataIndex: 'recharge_rate',
        align: 'center',
        width: 140,
      },
      {
        title: '撞线完成率',
        dataIndex: 'complete_overflow',
        align: 'center',
        width: 120,
      },
      {
        title: '在投门店数量增长',
        dataIndex: 'investing_rate',
        align: 'center',
        width: 160,
      },
      {
        title: '合并支付完成投放',
        dataIndex: 'deployed_qualified',
        align: 'center',
        width: 160,
      },
      {
        title: '响应时长',
        dataIndex: 'response_time',
        align: 'center',
        width: 120,
      },
      {
        title: '门店客诉',
        dataIndex: 'customer_complaint',
        align: 'center',
        width: 120,
      },
      {
        title: '运营月考',
        dataIndex: 'monthly_test',
        align: 'center',
        width: 120,
      },
    ],
  },
];
// 运营绩效KA组长标签数据模型
const PerformanceLeaderKa: any[] = [
  {
    title: '部长',
    dataIndex: 't_leader',
    align: 'center',
    width: 120,
  },
  {
    title: '组长',
    dataIndex: 'leader',
    align: 'center',
    width: 120,
  },
  {
    title: '总分',
    dataIndex: 'total_score',
    align: 'center',
    width: 120,
  },
  {
    title: '小组推广通金额',
    dataIndex: 'real_price_all',
    align: 'center',
    width: 140,
  },
  {
    title: '客观得分',
    dataIndex: 'one',
    align: 'center',
    children: [
      {
        title: 'SKU上品(5分)',
        dataIndex: 'sku_score',
        align: 'center',
        width: 140,
      },
      {
        title: '品牌权益配置(5分)',
        dataIndex: 'brand_equity',
        align: 'center',
        width: 160,
      },
      {
        title: '门店巡店/异常处理(5分)',
        dataIndex: 'inspection_and_exp',
        align: 'center',
        width: 200,
      },
      {
        title: '活动招商(5分)',
        dataIndex: 'activity_investment',
        align: 'center',
        width: 140,
      },
      {
        title: '门店客诉(10分)',
        dataIndex: 'customer_complaint',
        align: 'center',
        width: 140,
      },
      {
        title: '响应时长(10分)',
        dataIndex: 'response_time',
        align: 'center',
        width: 140,
      },
      {
        title: '应充实充率增长(10分)',
        dataIndex: 'recharge_rate',
        align: 'center',
        width: 180,
      },
      {
        title: '品牌续费率(50分)',
        dataIndex: 'brand_renew_rate',
        align: 'center',
        width: 160,
      },
    ],
  },
];

const PromotionColumns: any[] = [
  {
    title: '部长',
    dataIndex: 'leader',
    align: 'center',
    scopedSlots: { customRender: 'leader' },
    width: 120,
  },
  {
    title: '部推广通目标',
    dataIndex: 'monthTarget',
    align: 'center',
    width: 120,
  },
  {
    title: '部已完成金额',
    dataIndex: 'monthCompleted',
    align: 'center',
    width: 120,
  },
  {
    title: '部完成进度',
    dataIndex: 'monthCompletedRate',
    align: 'center',
    width: 120,
  },
  {
    title: '组推广通目标',
    dataIndex: 'groupTarget',
    align: 'center',
    width: 120,
  },
  {
    title: '组已完成金额',
    dataIndex: 'groupCompleted',
    align: 'center',
    width: 120,
  },
  {
    title: '组完成进度',
    dataIndex: 'groupCompletedRate',
    align: 'center',
    width: 120,
  },
  {
    title: '组别',
    dataIndex: 'group',
    align: 'center',
    width: 120,
  },
  {
    title: '组长',
    dataIndex: 'groupLeader',
    align: 'center',
    width: 120,
  },
  {
    title: '组员',
    dataIndex: 'groupMember',
    align: 'center',
    width: 120,
  },
  {
    title: '个人推广通目标',
    dataIndex: 'personalTarget',
    align: 'center',
    width: 150,
  },
  {
    title: '个人已完成金额',
    dataIndex: 'personalCompleted',
    align: 'center',
    width: 150,
  },
  {
    title: '个人今日业绩',
    dataIndex: 'personalTodayPerformance',
    align: 'center',
    width: 120,
  },
  {
    title: '个人推广通业绩完成率',
    dataIndex: 'personalCompletedRate',
    align: 'center',
    width: 200,
  },
];

const PromotionCompletion: any = [
  {
    title: '部长',
    dataIndex: 'dept_leader',
    align: 'center',
    scopedSlots: { customRender: 'dept_leader' },
    width: 120,
  },
  {
    title: '部门',
    dataIndex: 'dept_name',
    align: 'center',
    scopedSlots: { customRender: 'dept_name' },
    width: 120,
  },
  {
    title: '部推广通充值目标',
    dataIndex: 'monthTarget',
    align: 'center',
    width: 160,
  },
  {
    title: '部已完成金额',
    dataIndex: 'monthCompleted',
    align: 'center',
    width: 120,
  },
  {
    title: '部完成进度',
    dataIndex: 'monthCompletedRate',
    align: 'center',
    width: 120,
  },
  {
    title: '组别',
    dataIndex: 'group_name',
    align: 'center',
    width: 120,
  },
  {
    title: '组长',
    dataIndex: 'group_leader',
    align: 'center',
    width: 120,
  },
  {
    title: '组推广通充值目标',
    dataIndex: 'groupTarget',
    align: 'center',
    width: 160,
  },
  {
    title: '组已完成金额',
    dataIndex: 'groupCompleted',
    align: 'center',
    width: 120,
  },
  {
    title: '组完成进度',
    dataIndex: 'groupCompletedRate',
    align: 'center',
    width: 120,
  },
  {
    title: '组员',
    dataIndex: 'username',
    align: 'center',
    width: 120,
  },
  {
    title: '个人推广通目标',
    dataIndex: 'target_quota',
    align: 'center',
    width: 150,
  },
  {
    title: '个人已完成金额',
    dataIndex: 'month_real_price',
    align: 'center',
    width: 150,
  },
  // {
  //   title: '个人今日业绩',
  //   dataIndex: 'personalTodayPerformance',
  //   align: 'center',
  //   width: 120,
  // },
  {
    title: '个人推广通业绩完成率',
    dataIndex: 'ratio',
    align: 'center',
    width: 200,
    customRender: (text: any) => {
      if (text) {
        return `${(text * 100).toFixed(2)}%`;
      }
      return text;
    },
  },
];

// 推广通消耗完成率
const promotionCompletionRate: any[] = [
  {
    title: '部',
    dataIndex: 'dept_name',
    align: 'center',
    width: 120,
  },

  {
    title: '部消耗目标',
    dataIndex: 'monthTarget',
    align: 'center',
    width: 150,
  },
  {
    title: '部已完成',
    dataIndex: 'monthCompleted',
    align: 'center',
    width: 150,
  },
  {
    title: '部完成度',
    dataIndex: 'monthCompletedRate',
    align: 'center',
    width: 150,
  },
  {
    title: '组',
    dataIndex: 'group_name',
    align: 'center',
    width: 120,
  },
  {
    title: '组消耗目标',
    dataIndex: 'groupTarget',
    align: 'center',
    width: 150,
  },
  {
    title: '组已完成',
    dataIndex: 'groupCompleted',
    align: 'center',
    width: 150,
  },
  {
    title: '组完成度',
    dataIndex: 'groupCompletedRate',
    align: 'center',
    width: 150,
  },
  {
    title: '组员',
    dataIndex: 'username',
    align: 'center',
    width: 150,
  },
  {
    title: '个人消耗目标',
    dataIndex: 'target_quota',
    align: 'center',
    width: 150,
  },
  {
    title: '个人已完成',
    dataIndex: 'month_real_price',
    align: 'center',
    width: 150,
  },
  {
    title: '个人完成度',
    dataIndex: 'ratio',
    align: 'center',
    width: 150,
    customRender: (text: any) => {
      if (text) {
        return `${(text * 100).toFixed(2)}%`;
      }
      return text;
    },
  },
];

// 推广通日常数据
const PromoteDailyData: any[] = [
  {
    title: '部门',
    dataIndex: 'department',
    align: 'center',
    width: 120,
  },
  {
    title: '组',
    dataIndex: 'group',
    align: 'center',
    width: 120,
  },
  {
    title: '代运营',
    dataIndex: 'proxyOperation',
    align: 'center',
    width: 120,
  },
  {
    title: '城市',
    dataIndex: 'city',
    align: 'center',
    width: 120,
  },
  {
    title: '门店名称',
    dataIndex: 'storeName',
    align: 'center',
    width: 120,
  },
  {
    title: 'POI',
    dataIndex: 'poi',
    align: 'center',
    width: 120,
  },
  {
    title: '门店状态',
    dataIndex: 'storeStatus',
    align: 'center',
    width: 120,
  },
  {
    title: '广告主ID',
    dataIndex: 'advertiserId',
    align: 'center',
    width: 120,
  },
  {
    title: '是否在投',
    dataIndex: 'isAdvertising',
    align: 'center',
    width: 120,
  },
  {
    title: '广告主余额',
    dataIndex: 'advertiserBalance',
    align: 'center',
    width: 120,
  },
  {
    title: '余额可消耗天数',
    dataIndex: 'balanceConsumableDays',
    align: 'center',
    width: 140,
  },
  {
    title: '最近7天日均消耗金额',
    dataIndex: 'averageDailyConsumptionLast7Days',
    align: 'center',
    width: 240,
  },
  {
    title: '累计充值金额',
    dataIndex: 'totalRechargeAmount',
    align: 'center',
    width: 120,
  },
  {
    title: '累计消耗金额',
    dataIndex: 'totalConsumptionAmount',
    align: 'center',
    width: 120,
  },
  {
    title: '最近一次充值时间',
    dataIndex: 'lastRechargeTime',
    align: 'center',
    width: 200,
  },
  {
    title: '最近一次消耗时间',
    dataIndex: 'lastConsumptionTime',
    align: 'center',
    width: 200,
  },
];

// 广告主跟进数据
const AdvertiserFollowUp: any[] = [
  {
    title: '部',
    dataIndex: 'department',
    align: 'center',
    width: 120,
  },
  {
    title: '组',
    dataIndex: 'group',
    align: 'center',
    width: 120,
  },
  {
    title: '代运营',
    dataIndex: 'agencyOperation',
    align: 'center',
    width: 120,
  },
  {
    title: '门店名称',
    dataIndex: 'storeName',
    align: 'center',
    width: 120,
  },
  {
    title: '城市',
    dataIndex: 'city',
    align: 'center',
    width: 120,
  },
  {
    title: '标签类目',
    dataIndex: 'tagCategory',
    align: 'center',
    width: 120,
  },
  {
    title: '主营业务',
    dataIndex: 'mainBusiness',
    align: 'center',
    width: 120,
  },
  {
    title: '门店状态',
    dataIndex: 'storeStatus',
    align: 'center',
    width: 120,
  },
  {
    title: '近30天在投天数',
    dataIndex: 'daysInOperationLast30Days',
    align: 'center',
    width: 140,
  },
  {
    title: '充值次数',
    dataIndex: 'rechargeCount',
    align: 'center',
    width: 120,
  },
  {
    title: '是否应充',
    dataIndex: 'shouldRecharge',
    align: 'center',
    width: 120,
  },
  {
    title: '是否在投',
    dataIndex: 'isInOperation',
    align: 'center',
    width: 120,
  },
  {
    title: '日预算',
    dataIndex: 'dailyBudget',
    align: 'center',
    width: 120,
  },
  {
    title: '跟进优先级',
    dataIndex: 'followUpPriority',
    align: 'center',
    width: 120,
  },
  {
    title: '最近一次充值时间',
    dataIndex: 'lastRechargeTime',
    align: 'center',
    width: 200,
  },
  {
    title: '商户通续充末次拜访时间',
    dataIndex: 'lastMerchantVisitTimeForContinuedCharging',
    align: 'center',
    width: 200,
  },
  {
    title: '商户通续签拜访次数',
    dataIndex: 'merchantVisitCountForContinuedSigning',
    align: 'center',
    width: 180,
  },
  {
    title: '沟通结果',
    dataIndex: 'communicationResult',
    align: 'center',
    width: 120,
  },
  {
    title: '预计续签时间',
    dataIndex: 'expectedSigningTime',
    align: 'center',
    width: 200,
  },
  {
    title: '不续签原因',
    dataIndex: 'reasonForNotSigning',
    align: 'center',
    width: 200,
  },
  {
    title: '二次动作',
    dataIndex: 'secondaryAction',
    align: 'center',
    width: 120,
  },
  {
    title: '续签结果',
    dataIndex: 'signingResult',
    align: 'center',
    width: 120,
  },
  {
    title: '操作',
    dataIndex: 'operation',
    align: 'center',
    scopedSlots: { customRender: 'action' },
    fixed: 'right',
    width: 120,
  },
];

// 洗车节活动数据数据表头
const PerformanceTargetConfiguration: any = {
  // 部门
  departmentC: [
    {
      title: '部门',
      dataIndex: 'dept_name',
      align: 'center',
      width: 120,
    },
    {
      title: '部长',
      dataIndex: 'dept_manager',
      align: 'center',
      width: 120,
    },
    {
      title: '部门目标数',
      dataIndex: 'dept_activity_target_num',
      align: 'center',
      width: 120,
    },
    {
      title: '部门完成数',
      dataIndex: 'dept_activity_num',
      align: 'center',
      width: 120,
    },
    {
      title: '部门完成率',
      dataIndex: 'dept_activity_ratio',
      align: 'center',
      width: 120,
    },
  ],
  // 组
  graphicalGroup: [
    {
      title: '组',
      dataIndex: 'group_name',
      align: 'center',
      width: 120,
    },
    {
      title: '组长',
      dataIndex: 'group_manager',
      align: 'center',
      width: 120,
    },
    {
      title: '组目标数',
      dataIndex: 'group_activity_target_num',
      align: 'center',
      width: 120,
    },
    {
      title: '组完成数',
      dataIndex: 'group_activity_num',
      align: 'center',
      width: 120,
    },
    {
      title: '组完成率',
      dataIndex: 'group_activity_ratio',
      align: 'center',
      width: 120,
    },
  ],
  graphicalChild: [
    {
      title: '部门',
      dataIndex: 'dept_name',
      align: 'center',
      width: 120,
    },
    {
      title: '部长',
      dataIndex: 'dept_manager',
      align: 'center',
      width: 120,
    },
  ],
  // 组员
  TeamMemberSuperior: [
    {
      title: '部门',
      dataIndex: 'dept_name',
      align: 'center',
      width: 120,
    },
    {
      title: '部长',
      dataIndex: 'dept_manager',
      align: 'center',
      width: 120,
    },
    {
      title: '组',
      dataIndex: 'group_name',
      align: 'center',
      width: 120,
    },
    {
      title: '组长',
      dataIndex: 'group_manager',
      align: 'center',
      width: 120,
    },
  ],
  // 基础信息
  grinfo: [
    {
      title: '姓名',
      dataIndex: 'username',
      align: 'center',
      width: 120,
    },
    {
      title: '正常营业门店数',
      dataIndex: 'shop_num',
      align: 'center',
      width: 160,
    },
    {
      title: '活动目标数',
      dataIndex: 'activity_target_num',
      align: 'center',
      width: 120,
    },
    {
      title: '参与活动门店数',
      dataIndex: 'activity_num',
      align: 'center',
      width: 120,
    },
    {
      title: '活动完成率',
      dataIndex: 'activity_complete_ratio',
      align: 'center',
      width: 120,
      customRender: (text: any) => {
        // console.log(text);
        if (text) {
          return `${(Number(text) * 100).toFixed(2)}%`;
        }
        return '0';
      },
    },
    {
      title: '本月新入驻门店数',
      dataIndex: 'new_shop_num',
      align: 'center',
      width: 120,
    },
    {
      title: '新入驻门店参与活动数',
      dataIndex: 'new_shop_activity_num',
      align: 'center',
      width: 120,
    },
  ],
  // 操作
  action: [
    {
      title: '操作',
      dataIndex: 'action',
      align: 'center',
      fixed: 'right',
      scopedSlots: { customRender: 'action' },
      width: 120,
    },
  ],
};
// CPS标品招商数据
const CPSInvestmentPromotion: any = {
  // 部门
  department: [
    {
      title: '部门', dataIndex: 'dept_name', align: 'center', width: 120,
    },
    {
      title: '部长', dataIndex: 'dept_manager', align: 'center', width: 120,
    },
    {
      title: '参加活动目标数量', dataIndex: 'dept_target_quota', align: 'center', width: 160,
    },
    {
      title: '参加活动数量', dataIndex: 'dept_activity_num', align: 'center', width: 120,
    },
    {
      title: '活动完成度', dataIndex: 'dept_ratio', align: 'center', width: 120,
    },
  ],
  // 组长补充上级信息
  supplementGroupLeader: [
    {
      title: '部门', dataIndex: 'dept_name', align: 'center', width: 120,
    },
    {
      title: '部长', dataIndex: 'dept_manager', align: 'center', width: 120,
    },
  ],
  // 组
  groupLeader: [
    {
      title: '组', dataIndex: 'group_name', align: 'center', width: 120,
    },
    {
      title: '组长', dataIndex: 'group_manager', align: 'center', width: 120,
    },
    {
      title: '参加活动目标数量', dataIndex: 'group_target_quota', align: 'center', width: 160,
    },
    {
      title: '参加活动数量', dataIndex: 'group_activity_num', align: 'center', width: 120,
    },
    {
      title: '活动完成度', dataIndex: 'group_ratio', align: 'center', width: 120,
    },
  ],
  // 组员补充上级信息
  supplementTitleColumns: [
    {
      title: '部门', dataIndex: 'dept_name', align: 'center', width: 120,
    },
    {
      title: '部长', dataIndex: 'dept_manager', align: 'center', width: 120,
    },
    {
      title: '组', dataIndex: 'group_name', align: 'center', width: 120,
    },
    {
      title: '组长', dataIndex: 'group_manager', align: 'center', width: 120,
    },
  ],
  // 基础信息
  titleColumns: [
    {
      title: '组员', dataIndex: 'agent_name', align: 'center', width: 120,
    },
    // {
    //   title: 'CPS标品名称', dataIndex: 'goods_name', align: 'center', width: 120,
    // },
    {
      title: '参加活动目标数量', dataIndex: 'target_quota', align: 'center', width: 160,
    },
    {
      title: '参加活动数量', dataIndex: 'shop_num', align: 'center', width: 120,
    },
    {
      title: '活动完成度', dataIndex: 'ratio', align: 'center', width: 120,
    },
    {
      title: '操作', dataIndex: 'action', align: 'center', width: 120, fixed: 'right', scopedSlots: { customRender: 'action' },
    },
  ],
};
const WriteGMVAmount: any = {
  // 部门
  department: [
    {
      title: '部门', dataIndex: 'dept_name', align: 'center', width: 120,
    },
    {
      title: '部长', dataIndex: 'dept_manager', align: 'center', width: 120,
    },
    {
      title: '核销GMV目标金额', dataIndex: 'dept_gmv_target', align: 'center', width: 180,
    },
    {
      title: '已完成核销GMV金额', dataIndex: 'dept_gmv', align: 'center', width: 180,
    },
    {
      title: 'GMV完成度', dataIndex: 'dept_gmv_ratio', align: 'center', width: 120,
    },
  ],
  // 组长补充上级信息
  supplementGroupLeader: [
    {
      title: '部门', dataIndex: 'dept_name', align: 'center', width: 120,
    },
    {
      title: '部长', dataIndex: 'dept_manager', align: 'center', width: 120,
    },
  ],
  // 组
  groupLeader: [
    {
      title: '组', dataIndex: 'group_name', align: 'center', width: 120,
    },
    {
      title: '组长', dataIndex: 'group_manager', align: 'center', width: 120,
    },
    {
      title: '核销GMV目标金额', dataIndex: 'group_gmv_target', align: 'center', width: 180,
    },
    {
      title: '已完成核销GMV金额', dataIndex: 'group_gmv', align: 'center', width: 180,
    },
    {
      title: 'GMV完成度', dataIndex: 'group_gmv_ratio', align: 'center', width: 120,
    },
  ],
  // 组员补充上级信息
  supplementTitleColumns: [
    {
      title: '部门', dataIndex: 'dept_name', align: 'center', width: 120,
    },
    {
      title: '部长', dataIndex: 'dept_manager', align: 'center', width: 120,
    },
    {
      title: '组', dataIndex: 'group_name', align: 'center', width: 120,
    },
    {
      title: '组长', dataIndex: 'group_manager', align: 'center', width: 120,
    },
  ],
  // 基础信息
  titleColumns: [
    {
      title: '组员', dataIndex: 'username', align: 'center', width: 120,
    },
    {
      title: '核销GMV目标金额', dataIndex: 'gmv_target', align: 'center', width: 180,
    },
    {
      title: '已完成核销GMV金额', dataIndex: 'gmv', align: 'center', width: 180, customRender: (text: any) => { return text || '0.00'; },
    },
    {
      title: 'GMV完成度', dataIndex: 'gmv_ratio', align: 'center', width: 120, customRender: (text: any) => { return text || '0.00'; },
    },
  ],
  action: [
    {
      title: '操作', dataIndex: 'action', align: 'center', scopedSlots: { customRender: 'action' }, width: 120,
    },
  ],
  actionRight: [
    {
      title: '操作', dataIndex: 'action', align: 'center', fixed: 'right', scopedSlots: { customRender: 'action' }, width: 120,
    },
  ],
};

// 推广通充值门店列表
const ListRechargeStores: any = {

  // 部门
  department: [
    {
      title: '部门', dataIndex: 'dept_name', align: 'center', width: 120,
    },
    {
      title: '部长', dataIndex: 'dept_manager', align: 'center', width: 120,
    },
    {
      title: '部门充值门店数量', dataIndex: 'dept_shop_num', align: 'center', width: 120,
    },
  ],
  // 组长补充上级信息
  supplementGroupLeader: [
    {
      title: '部门', dataIndex: 'dept_name', align: 'center', width: 120,
    },
    {
      title: '部长', dataIndex: 'dept_manager', align: 'center', width: 120,
    },
  ],
  // 组
  groupLeader: [
    {
      title: '组', dataIndex: 'group_name', align: 'center', width: 120,
    },
    {
      title: '组长', dataIndex: 'group_manager', align: 'center', width: 120,
    },
    {
      title: '组充值门店数量', dataIndex: 'group_shop_num', align: 'center', width: 120,
    },
  ],
  // 组员补充上级信息
  supplementTitleColumns: [
    {
      title: '部门', dataIndex: 'dept_name', align: 'center', width: 120,
    },
    {
      title: '部长', dataIndex: 'dept_manager', align: 'center', width: 120,
    },
    {
      title: '组别', dataIndex: 'group_name', align: 'center', width: 120,
    },
    {
      title: '组长', dataIndex: 'group_manager', align: 'center', width: 120,
    },
  ],


  titleColumns: [
    {
      title: '组员', dataIndex: 'agent_name', align: 'center', width: 120,
    },
    {
      title: '充值门店数量', dataIndex: 'shop_num', align: 'center', width: 120,
    },
    {
      title: '门店POI', dataIndex: 'poi', align: 'center', width: 120,
    },
    {
      title: '门店名称', dataIndex: 'shop_name', align: 'center', width: 120,
    },
    {
      title: '充值次数', dataIndex: 'recharge_num', align: 'center', width: 120,
    },
    {
      title: '最后一次充值时间', dataIndex: 'last_recharge_time', align: 'center', width: 120,
    },
    {
      title: '充值金额', dataIndex: 'recharge_amount', align: 'center', width: 120,
    },
  ],
};
